import React, { useState, useEffect } from "react";
import { Stepper, Step } from 'react-form-stepper';
// import { Button, Container, Row, Col } from 'react-bootstrap';
// import { useMappedState, useDispatch } from 'redux-react-hook';

export default function ProjectsCustStepper(props) {
    // const [isFetched, setIsFetched] = useState(false);

    function onClickStep(index) {
        console.log("[onClickStep]", index);
        if (props.pid) {
            props.history.push('/proj/edit/' + props.pid + '/' + (index));
        } else {
            alert("請先完成目前步驟");
        }
    }

    function render() {
        return (
            <div>
                {/* <Stepper steps={[
                    { label: '新增專案' },
                    { label: '問卷編輯' },
                    { label: '跳題設定' },
                    { label: '派送對象' },
                    { label: '發出測試' }]
                } nonLinear={true}
                    activeStep={props.step} styleConfig={{
                        activeBgColor: "#4B6864",
                        completedBgColor: "#4B6864",
                        inactiveBgColor: "#9FBDB9"
                    }} onClick={(key) => { onClickStep(key) }} /> */}
                <Stepper activeStep={props.step} styleConfig={{
                    activeBgColor: "#00b7ff",
                    completedBgColor: "#00b7ff",
                    inactiveBgColor: "#daf4fe",
                    inactiveTextColor: "#7c838a",
                    circleFontSize: '1.2rem',
                    labelFontSize: '1rem'
                }} activeStep={false == props.isEditable ? 6 : 3} >
                    <Step className={props.step >= 0 ? "active" : ""} label="修改問卷資料" onClick={() => { onClickStep(1) }} />
                    <Step className={props.step >= 1 ? "active" : ""} label="問卷編輯" onClick={() => { onClickStep(2) }} />
                    <Step className={props.step >= 2 ? "active" : ""} label={"跳題設定\n及測試"} onClick={() => { onClickStep(3) }} />
                    <Step className={props.step >= 3 ? "active" : ""} label={"派送對象及\n消耗點數確認"} onClick={() => { onClickStep(4) }} />
                    <Step className={props.step >= 4 ? "active" : ""} label={"填答結果"} onClick={() => { onClickStep(5) }} />
                    <Step className={props.step >= 5 ? "active" : ""} label={"次數分配表"} onClick={() => { onClickStep(6) }} />
                    {/* <Step className={props.step >= 4 ? "active" : ""} label="發出測試" onClick={() => { onClickStep(5) }} /> */}
                </Stepper>
            </div>

        );
    }
    return render();
}
